import { constVoid, DOM, IOO, pipe, RNEA, RR, s, v } from '@packages/prelude'
import { Swiper, SwiperOptions, Pagination, Autoplay } from 'swiper'

import '../css/main.scss'
import 'bootstrap'

const makeSwiper = (selector: string, options: SwiperOptions) =>
  pipe(
    IOO.of({ document }),
    IOO.chain(
      ({ document }) =>
        pipe(document, DOM.querySelectorAll(`.${selector}`)) as IOO.IOOption<RNEA.ReadonlyNonEmptyArray<HTMLElement>>
    ),
    IOO.fold(
      () => constVoid,
      elements =>
        IOO.of(
          pipe(
            elements,
            RNEA.map(element => new Swiper(element, options))
          )
        )
    )
  )()

const Swipers: Record<string, SwiperOptions> = {
  'swiper-2-elements': {
    direction: 'horizontal',
    modules: [Pagination],
    slidesPerView: 1,
    breakpoints: {
      576: {
        slidesPerView: 2
      }
    },
    pagination: {
      el: '.swiper-pagination'
    }
  },
  'swiper-3-elements': {
    direction: 'horizontal',
    modules: [Pagination],
    slidesPerView: 1,
    breakpoints: {
      576: {
        slidesPerView: 2
      },
      1200: {
        slidesPerView: 3
      }
    },
    pagination: {
      el: '.swiper-pagination'
    }
  },
  'swiper-gallery': {
    direction: 'horizontal',
    modules: [Pagination, Autoplay],
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    speed: 750,
    loop: true,
    autoplay: true
  }
}

pipe(
  Swipers,
  RR.foldMapWithIndex(s.Ord)(v.Monoid)((selector, options) => makeSwiper(selector, options))
)

pipe(
  IOO.of({ document }),
  IOO.chain(({ document }) => pipe(document, DOM.querySelectorAll('.collapsible-complex')) as IOO.IOOption<RNEA.ReadonlyNonEmptyArray<HTMLElement>>),
  IOO.chainFirstIOK(collapsibles => () => (
      pipe(
        collapsibles,
        RNEA.map(collapsible => {
          const collapseElement = collapsible.querySelector('.collapsible-item > div')
          const btnElement = collapsible.querySelector('.collapsible-item > a')

          if (collapseElement && btnElement) {
            const contentHeight = collapseElement.scrollHeight
            const lineHeight = parseFloat(window.getComputedStyle(collapseElement).lineHeight)

            if (contentHeight <= lineHeight * 3) {
              btnElement.classList.add('d-none')
            }
          }
        })
      )
    )
  )
)()

pipe(
  IOO.of({ document }),
  IOO.chain(({ document }) => pipe(document, DOM.querySelectorAll('.collapsible-complex .accordion-item')) as IOO.IOOption<RNEA.ReadonlyNonEmptyArray<HTMLElement>>),
  IOO.chainFirstIOK(collapsibles => () => (
      pipe(
        collapsibles,
        RNEA.map(collapsible => {
          const collapseElement = collapsible.querySelector('.accordion-collapse')
          const btnElement = collapsible.querySelector('.accordion-button')

          if (collapseElement && btnElement) {
            const contentHeight = collapseElement.scrollHeight
            const lineHeight = parseFloat(window.getComputedStyle(collapseElement).lineHeight)

            if (contentHeight <= lineHeight * 3) {
              btnElement.classList.add('d-none')
            }
          }
        })
      )
    )
  )
)()

pipe(
  IOO.of({ document }),
  IOO.bind('form', ({ document }) => pipe(document, DOM.querySelector('#bite-sync-form'))),
  IOO.bind('spinner', ({ document }) => pipe(document, DOM.querySelector('.syncing-bite'))),
  IOO.chainFirstIOK(({ form, spinner }) =>
    DOM.addEventListener('submit')(() => () => {
      spinner.classList.remove('d-none')
    })(form)
  )
)()
